import React, { useState, useCallback, useEffect } from "react";
import { useHistory } from "react-router-dom";

import Header from "../../../../components/molecules/Header";
import useStyles from "./style";
import MaskedInput from "react-text-mask";
import PropTypes from "prop-types";
import isMobilePhone from "../../../../utils/isMobilePhone";
import isAlphanumeric from "validator/lib/isAlphanumeric";
import { useSnackbar } from "notistack";

import {
  Container,
  Grid,
  Button,
  OutlinedInput,
  InputLabel,
  InputAdornment,
  FormControl,
  Divider,
  FormHelperText,
  CircularProgress,
  Avatar,
} from "@material-ui/core";

import {
  subdomainsCollection,
  useData,
} from "../../../../components/firebase/DataProvider";

import { FieldValue } from "../../../../components/firebase/FirebaseProvider";

import Gap from "../../../../components/atoms/Gap";

const defaultLogo = require("../../../../assets/images/landing-image-third.png");

const NumberFormatCustom = (props) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[
        "+",
        /[1-9]/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ]}
      guide={false}
    />
  );
};

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

const UbahProfilToko = () => {
  const classes = useStyles();
  const { phone, profil, webstore, webstoreRef } = useData();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();

  const exp = /-/g;

  const [isSubmitting, setSubmitting] = useState(false);
  const [currentDomain, setCurrentDomain] = useState();

  const [currentWebstore] = useState({
    domain: `https://${webstore.domain}.tokorame.store`,
  });

  const [values, setValues] = useState({
    nama: "",
    domain: "",
    wa: "",
    errorStatus: false,
    errorType: "",
    errorMessage: "",
  });

  useEffect(() => {
    init();
  }, []);

  const init = useCallback(async () => {
    if (webstore) {
      const subdomain = await subdomainsCollection
        .where("user_id", "==", profil.id)
        .get();
      subdomain.docs.map((doc) => {
        setCurrentDomain(doc.id);
        setValues({
          nama: webstore.nama ? webstore.nama : "",
          domain: webstore.domain ? webstore.domain : "",
          wa: webstore.wa ? webstore.wa : "",
        });
      });
    }
  });

  const checkDomain = useCallback(async () => {
    const subdomain = await subdomainsCollection
      .doc(values.domain.toLowerCase())
      .get();
    return subdomain.exists;
  });

  const handleChange = (prop) => (event) => {
    setValues({
      ...values,
      [prop]: event.target.value,
      errorStatus: false,
      errorType: "",
      errorMessage: "",
    });
  };

  const handleError = (err) => {
    setValues({
      ...values,
      errorStatus: true,
      errorType: err,
      errorMessage:
        err === "nama"
          ? "Nama toko wajib diisi"
          : err === "wa"
          ? "Nomor wajib diisi"
          : err === "domain"
          ? "Domain wajib diisi"
          : err === "invalid"
          ? "No Whatsapp tidak valid"
          : err === "use"
          ? "Domain sudah digunakan"
          : err === "pernah"
          ? "Domain hanya bisa diubah sekali saja"
          : err === "kurang"
          ? "Domain toko minimal 3 karakter"
          : err === "terdiri"
          ? "Domain hanya boleh terdiri dari huruf dan angka"
          : null,
    });
  };

  const handleSubmit = useCallback(async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      const { wa, nama, domain } = values;
      let phoneRaw = wa.replace(exp, "");

      if (!nama) {
        throw new Error("nama");
      } else if (!domain) {
        throw new Error("domain");
      } else if (!wa) {
        throw new Error("wa");
      } else if (!isMobilePhone(phoneRaw)) {
        throw new Error("invalid");
      } else if (domain.length < 3) {
        throw new Error("kurang");
      } else if (!isAlphanumeric(domain)) {
        throw new Error("terdiri");
      } else if (currentDomain !== domain.toLowerCase()) {
        if (webstore?.changesubdomain >= 1) {
          throw new Error("pernah");
        }
        let exist = await checkDomain();
        if (exist) {
          throw new Error("use");
        }
      }

      let newWebstore = {
        nama: nama,
        domain: domain.toLowerCase(),
        wa: phoneRaw,
        updated_at: FieldValue.serverTimestamp(),
      };

      if (domain.toLowerCase() !== currentDomain) {
        newWebstore.changesubdomain = FieldValue.increment(1);
      }

      webstoreRef.set(newWebstore, { merge: true });

      if (currentDomain) await subdomainsCollection.doc(currentDomain).delete();

      subdomainsCollection.doc(domain.toLowerCase()).set({
        user_id: profil.id,
      });
      history.goBack();

      enqueueSnackbar("Profil Toko Berhasil Diupdate", {
        variant: "success",
      });
    } catch (err) {
      setSubmitting(false);
      console.log(err.message);
      handleError(err.message);
    }
    setSubmitting(false);
  });

  return (
    <>
      <Header
        type="with-title"
        title="Ubah Profil Toko"
        onClick={() => history.goBack()}
      />
      <Container>
        <div className={classes.wrapHeader}>
          <div className={classes.wrapAvatar}>
            <Avatar
              className={classes.large}
              src={!webstore.logo ? defaultLogo : webstore.logo}
            />
          </div>
          <Gap width={16} />
          <div>
            <p>{profil.nama}</p>
            <p>{phone?.id}</p>
            <p>{currentWebstore.domain}</p>
          </div>
        </div>
        <Divider />
        <div className={classes.content}>
          <form onSubmit={handleSubmit} style={{ width: "100%" }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={6}>
                <FormControl
                  variant="outlined"
                  fullWidth
                  className={classes.input_form}
                  disabled={isSubmitting}
                  style={{ marginBottom: "25px" }}
                  error={
                    values.errorStatus
                      ? values.errorType === "nama"
                        ? values.errorStatus
                        : null
                      : null
                  }
                >
                  <InputLabel htmlFor="outlined-adornment-nama">
                    Nama Toko
                  </InputLabel>
                  <OutlinedInput
                    value={values.nama}
                    id="outlined-adornment-nama"
                    label="Nama Toko"
                    placeholder="Kuma Store"
                    onChange={handleChange("nama")}
                  ></OutlinedInput>
                  {values.errorStatus ? (
                    values.errorType === "nama" ? (
                      <FormHelperText>{values.errorMessage}</FormHelperText>
                    ) : null
                  ) : null}
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <FormControl
                  variant="outlined"
                  fullWidth
                  className={classes.input_form}
                  disabled={isSubmitting || webstore?.changesubdomain >= 1}
                  style={{ marginBottom: "25px" }}
                  error={
                    values.errorStatus
                      ? values.errorType === "domain" ||
                        values.errorType === "use" ||
                        values.errorType === "pernah" ||
                        values.errorType === "kurang" ||
                        values.errorType === "terdiri"
                        ? values.errorStatus
                        : null
                      : null
                  }
                >
                  <InputLabel htmlFor="outlined-adornment-domain">
                    Domain Toko
                  </InputLabel>
                  <OutlinedInput
                    value={values.domain}
                    id="outlined-adornment-domain"
                    label="Domain Toko"
                    placeholder="kuma"
                    onChange={handleChange("domain")}
                    endAdornment={
                      <InputAdornment position="end">
                        tokorame.store
                      </InputAdornment>
                    }
                  ></OutlinedInput>
                  {values.errorStatus ? (
                    values.errorType === "domain" ||
                    values.errorType === "use" ||
                    values.errorType === "pernah" ||
                    values.errorType === "kurang" ? (
                      <FormHelperText>{values.errorMessage}</FormHelperText>
                    ) : (
                      <FormHelperText>
                        Nama domain hanya boleh terdiri dari huruf dan angka
                        saja, tidak boleh mengandung tanda khusus berikut ( ! @
                        # $ % ^ & * _ + ~ )
                      </FormHelperText>
                    )
                  ) : (
                    <FormHelperText>
                      Nama domain hanya boleh terdiri dari huruf dan angka saja,
                      tidak boleh mengandung tanda khusus berikut ( ! @ # $ % ^
                      & * _ + ~ )
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>
            </Grid>
            <FormControl
              variant="outlined"
              fullWidth
              className={classes.input_form}
              disabled={isSubmitting}
              style={{ marginBottom: "25px" }}
              error={
                values.errorStatus
                  ? values.errorType === "wa"
                    ? values.errorStatus
                    : null
                  : null
              }
            >
              <InputLabel htmlFor="outlined-adornment-domain">
                No Kontak / WA Toko
              </InputLabel>
              <OutlinedInput
                value={values.wa}
                autoFocus={values.autoFocus}
                id="outlined-adornment-wa"
                label="No Kontak / WA Toko"
                placeholder="+62-852-1234-5678"
                onChange={handleChange("wa")}
                inputComponent={NumberFormatCustom}
              ></OutlinedInput>
              {values.errorStatus ? (
                values.errorType === "wa" ? (
                  <FormHelperText>{values.errorMessage}</FormHelperText>
                ) : null
              ) : null}
            </FormControl>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={isSubmitting}
              style={{
                position: "relative",
                letterSpacing: "1px",
                fontWeight: "bold",
                borderRadius: "8px",
                paddingTop: "12px",
                paddingBottom: "12px",
                bottom: 0,
                left: 0,
                width: "100%",
              }}
            >
              {isSubmitting === true && (
                <CircularProgress
                  size={24}
                  className={classes.buttonProgress}
                />
              )}
              {!isSubmitting ? "simpan info toko" : null}
            </Button>
          </form>
        </div>
      </Container>
    </>
  );
};

export default UbahProfilToko;
